const allPromos = [
    {
        sportkey: "golf",
        code: "ANALYZER26",
        expires: "2026-06-22",
        name: "US Open Special",
        description: "30 days free then $9.99/year.",
        normalPrice: "$29.99/year",
        globalTag: "30 days free"
    },
    {
        sportkey: "global",
        code: "ANALYZER26",
        expires: "2026-06-22",
        name: "US Open Special",
        description: "30 days free then $9.99/year.",
        normalPrice: "$29.99/year",
        globalTag: "30 days free"
    },
    {
        sportkey: "cricket_off",
        code: "ANALYZER26",
        expires: "2026-05-31",
        name: "New Season Special",
        description: "Try free for 30 days, then just $9.99/year.",
        normalPrice: "$29.99/year",
        globalTag: "30 days free"
    }
]

const getPromo = (key) => {
    const promo = allPromos.find(p => p.sportkey === key);

    if(promo && new Date(promo.expires) > new Date())
    {
        return promo;
    }

    return null;
}


export {getPromo}